import { Router } from './routes';
import './style.css';

function App() {
  return (<Router />);
}

export default App;
